ACC.cartgtm = {

    _autoload: [],

    addToCartGtm(ecommerceProductData) {
        dataLayer.push({
            ecom_addtocart: {
                isbn: ecommerceProductData.isbn,
                businessModelCode: ecommerceProductData.businessModelCode,
                discountPrice: ecommerceProductData.discountPrice,
                duration: ecommerceProductData.duration,
                name: ecommerceProductData.name,
                position: ecommerceProductData.position,
                price: ecommerceProductData.price,
                productId: ecommerceProductData.productId,
                program: ecommerceProductData.program,
                quantity: ecommerceProductData.quantity,
                sourceContext: ecommerceProductData.sourceContext,
            },
        });
    },

    removeFromCartGtm(isbn) {
        const ecommerceProductData = dataLayer[0].ecommerce[isbn];
        if (ecommerceProductData === 'undefined') {
            return;
        }
        dataLayer.push({
            ecom_removefromcart: {
                isbn,
                businessModelCode: ecommerceProductData.businessModelCode,
                discountPrice: ecommerceProductData.discountPrice,
                duration: ecommerceProductData.duration,
                name: ecommerceProductData.name,
                position: ecommerceProductData.position,
                price: ecommerceProductData.price,
                productId: ecommerceProductData.productId,
                program: ecommerceProductData.program,
                quantity: ecommerceProductData.quantity,
                sourceContext: ecommerceProductData.sourceContext,
            },
        });
    },
};
